@if (diagnostics.length) {
  <details #issues class="notice-diagnostics">
    <summary>
      <strong role="status" aria-live="polite">
        {{ diagnostics.length }}
        {{ diagnostics.length === 1 ? "issue" : "issues" }}
      </strong>
      <span>Review issues</span>
    </summary>
    <ol aria-label="Composition diagnostics">
      @for (diagnostic of diagnostics; track $index) {
        @let issue = resolve(diagnostic);
        <li>
          <div class="issue-heading">
            <strong>{{ issue.title }}</strong>
            <span>{{ issue.affectedLabel }}</span>
          </div>
          <p>{{ diagnostic.message }}</p>
          <p class="issue-action">{{ diagnostic.action }}</p>
          <div class="issue-navigation">
            @for (target of issue.targets; track $index) {
              <button
                uiButton="secondary"
                type="button"
                [disabled]="disabled"
                [attr.aria-label]="'Go to issue: ' + target.label"
                (click)="goTo(diagnostic, target)"
              >
                @if (target.kind === "fields") {
                  Open Fields
                } @else if (issue.targets.length === 1) {
                  Go to issue
                } @else {
                  {{ target.label }}
                }
              </button>
            }
          </div>
          @if (issue.targets[0]?.kind === "fields") {
            <p class="source-guidance">
              Inspect the retained source in Fields; this issue has no verified
              page control.
            </p>
          }
          <details class="issue-technical">
            <summary>Technical details</summary>
            <dl>
              <dt>Path</dt>
              <dd>{{ diagnostic.path }}</dd>
              <dt>Code</dt>
              <dd>{{ diagnostic.code }}</dd>
            </dl>
          </details>
        </li>
      }
    </ol>
  </details>
}
